// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__145NP","list":"BalanceDue_list__1CDrU","listRow":"BalanceDue_listRow__2z17U","total":"BalanceDue_total__LjHiU"};